import React from 'react';

// Small stroke icons (24px grid), drawn in currentColor.
const PATHS = {
  chevronRight: <path d="M9 6l6 6-6 6" />,
  chevronDown:  <path d="M6 9l6 6 6-6" />,
  arrowRight:   <path d="M5 12h14M13 6l6 6-6 6" />,
  plus:         <path d="M12 5v14M5 12h14" />,
  minus:        <path d="M5 12h14" />,
  x:            <path d="M6 6l12 12M18 6L6 18" />,
  refresh:      <path d="M20 11a8 8 0 1 0-2.3 5.7M20 4v7h-7" />,
  download:     <path d="M12 4v11M7 10l5 5 5-5M5 20h14" />,
};

export default function Icon({ name, size = 16, strokeWidth = 2, className, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={className}
      {...rest}
    >
      {PATHS[name]}
    </svg>
  );
}
